if (!customElements.get('color-swatches')) {
  class ColorSwatches extends HTMLElement {
    connectedCallback() {
      this.context = this.dataset.context;

      if (this.context === 'card') {
        this.initCardSwatches();
      } else if (this.context === 'product') {
        this.initProductSwatches();
      }
    }

    initCardSwatches() {
      this.cardWrapper = this.closest('.card-wrapper');
      if (!this.cardWrapper) return;

      this.cardImage = this.cardWrapper.querySelector('.card__media .media img:first-child');
      if (!this.cardImage) return;

      this.secondaryImage = this.cardWrapper.querySelector('.card__media .media img:nth-child(2)');

      this.defaultSrc = this.cardImage.dataset.defaultSrc || this.cardImage.getAttribute('src');
      this.defaultSrcset =
        this.cardImage.dataset.defaultSrcset || this.cardImage.getAttribute('srcset');

      this.swatchLinks = this.querySelectorAll('.color-swatches__item--card');

      this.swatchLinks.forEach((swatch) => {
        swatch.addEventListener('mouseenter', this.onSwatchEnter.bind(this, swatch));
        swatch.addEventListener('focus', this.onSwatchEnter.bind(this, swatch));
      });

      this.addEventListener('mouseleave', (event) => {
        const related = event.relatedTarget;
        if (related && this.contains(related)) return;
        this.restoreCardImage();
      });

      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) {
          this.restoreCardImage();
        }
      });
    }

    onSwatchEnter(swatch) {
      const src = swatch.getAttribute('data-src');
      const srcset = swatch.getAttribute('data-srcset');
      if (!src || !this.cardImage) return;

      this.cardWrapper.classList.add('is-swatch-active');
      this.cardImage.setAttribute('src', src);
      if (srcset) {
        this.cardImage.setAttribute('srcset', srcset);
      }
      if (this.secondaryImage) {
        this.secondaryImage.style.opacity = '0';
      }
    }

    restoreCardImage() {
      if (!this.cardImage || !this.cardWrapper) return;

      this.cardWrapper.classList.remove('is-swatch-active');
      if (this.defaultSrc) {
        this.cardImage.setAttribute('src', this.defaultSrc);
      }
      if (this.defaultSrcset) {
        this.cardImage.setAttribute('srcset', this.defaultSrcset);
      } else {
        this.cardImage.removeAttribute('srcset');
      }
      if (this.secondaryImage) {
        this.secondaryImage.style.opacity = '';
      }
    }

    initProductSwatches() {
      const showAllButton = this.querySelector('button.color-swatches__show-all');
      if (!showAllButton) return;

      showAllButton.addEventListener('click', () => {
        this.classList.add('is-expanded');
        showAllButton.setAttribute('aria-expanded', 'true');
      });
    }
  }

  customElements.define('color-swatches', ColorSwatches);
}
